import { SELECT_TOOL, ADD_TOOL, TARGET_SQUARE, DESELECT_TOOLS } from './types';

export function selectTool ( tool, field, value ) {
  return {
    type : SELECT_TOOL,
    payload : {tool, field, value}
  }
}

export function addTool(tools) {
  return {
    type : ADD_TOOL,
    payload : tools,
  }
}

export function targetSquare ( square_id ) {
  return {
    type : TARGET_SQUARE,
    payload : square_id
  }
}

export function deselectTools() {
  return {
    type : DESELECT_TOOLS
  }
}



// WEBPACK FOOTER //
// ./src/actions/tools.js